/**
 * Hotjar loader
 */

require("./adapter")
require("./functions")
require("./event_listeners")
